export default "__VITE_ASSET__C8OCpYl0__"